import { BasicResponseDTO } from "@dto/basicResponse.dto";
import { DashboardGroup, DashboardItem, UpdateDashboardItemDTO } from "@dto/dashboard.dto";
import { API_URL } from "src/data/Api";
import { RoutePath } from "src/data/Routes";
import { MenuNode } from "src/model/MenuNode";
import { Log } from "src/service/log.service";
import { putApi } from "src/util/apiCalls";
import { GLOB } from "src/util/Glob";
import { MenuDataNode } from "./select/DashboardContextMenu";

export function makeDashboardDefault(dashboard: MenuDataNode) {
  return putApi(`${API_URL.DASHBOARD}${RoutePath.DASHBOARD}/${dashboard.itemId}/default`)
    .catch((reason) => Log.error(`Failed to make ${dashboard.titleText} default dashboard!`, reason));
}

export function saveItem(item: DashboardItem, group: DashboardGroup) {
  if (GLOB.userInfo.readonly && (MenuNode.getGroupId(GLOB.selectedItem) != null)) {
    return Promise.reject(new Error('Readonly'));
  }

  const dto = new UpdateDashboardItemDTO(item);
  dto.dashboard_group_id = group.dashboard_group_id;
  return putApi<BasicResponseDTO, UpdateDashboardItemDTO>(API_URL.DASHBOARD_ITEM + '/' + item.dashboard_item_id, dto)
    .catch((reason) => Log.error('Failed to save item!', reason));
}